export default {"src":"/_next/static/media/visa.0bb03569.svg","height":36,"width":109,"blurWidth":0,"blurHeight":0};